export const SESSION_STATUS = {
  PLANNED: 'PLANNED',     // Session geplant (✅ Matches Prisma Enum)
  WAITING: 'WAITING',     // Session gestartet, wartet auf Teilnehmer
  ACTIVE: 'ACTIVE',       // Session läuft mit aktiven Teilnehmern (✅ Timer Fix!)
  COMPLETED: 'COMPLETED', // Session beendet (✅ Matches Prisma Enum)
  CANCELLED: 'CANCELLED'  // Session abgebrochen (✅ Matches Prisma Enum)
};

export const SESSION_TYPE = {
  PRIVATE: 'PRIVATE',  // ✅ Matches Backend/Prisma Enum
  GROUP: 'GROUP',
  OPEN: 'OPEN'         // ✅ Matches Backend/Prisma Enum
};

export const PARTICIPANT_STATUS = {
  INVITED: 'INVITED',     // Nur bei privaten Sessions
  PENDING: 'PENDING',     // Beigetreten, aber nicht validiert (✅ Matches Backend)
  VALIDATED: 'VALIDATED', // Code eingegeben/QR gescannt (✅ Matches Backend)
  RESERVED: 'RESERVED',   // Platz reserviert (✅ Matches Backend)
  JOINED: 'JOINED',       // Aktiv in Session (✅ Matches Backend)
  REJECTED: 'REJECTED',   // Ablehnung durch Host (✅ Matches Backend)
  KICKED: 'KICKED',       // Entfernt durch Host (✅ Matches Backend)
  LEFT: 'LEFT',           // Hat Session verlassen - Audit-Trail (✅ Matches Backend)
  COMPLETED: 'COMPLETED'  // Session abgeschlossen
};
